// extracted by mini-css-extract-plugin
export default {"roomscene":"RoomScene_roomscene__qpMex","active":"RoomScene_active__6ZsOo"};